import { NgModule } from '@angular/core';
import { MsButtonComponent } from './ms-button.component';
import { SharedLibsModule } from 'app/shared/shared-libs.module';

@NgModule({
	declarations: [MsButtonComponent],
	imports: [SharedLibsModule],
	exports: [MsButtonComponent],
	providers: [],
})
export class MsButtonModule {}
